import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";
export const mensajeErrorRentabilidad = (error) => {
  const d = error?.response?.data || error;
  const texto = d?.error?.message || d?.error || d?.err?.message || d?.message;
  return typeof texto === "string" ? texto : "No se pudo obtener el informe. Revisá la conexión e intentá nuevamente.";
};
const opciones = () => ({ headers: { token: localStorage.getItem("token") || "" }, timeout: 35000 });

export async function getDashboardRentabilidad(filtros) {
  const params = {};
  ["desde", "hasta", "tipo", "baseIngreso", "camionId", "choferId", "transporteId"].forEach(k => {
    if (filtros[k]) params[k] = filtros[k];
  });
  const { data } = await axios.get(`${BASE_URL}/reportes/dashboard-rentabilidad`, { ...opciones(), params });
  if (!data?.ok) throw new Error(mensajeErrorRentabilidad(data));
  if (!data.resumen || !Array.isArray(data.detalle)) throw new Error("La respuesta del informe no tiene el formato esperado.");
  return data;
}

export async function getOpcionesRentabilidad() {
  const fuentes = [["camiones", "/camiones", { incluirInactivos: 1 }], ["choferes", "/choferes"], ["transportes", "/transportes"]];
  const respuestas = await Promise.allSettled(fuentes.map(async ([clave, ruta, params]) => {
    const { data } = await axios.get(`${BASE_URL}${ruta}`, { ...opciones(), params });
    if (!data?.ok || !Array.isArray(data[clave])) throw new Error("No se pudo cargar " + clave);
    return data[clave];
  }));
  const resultado = { camiones: [], choferes: [], transportes: [], avisos: [] };
  respuestas.forEach((r, i) => {
    const clave = fuentes[i][0];
    if (r.status === "fulfilled") resultado[clave] = r.value;
    else resultado.avisos.push(`No se cargó el selector de ${clave}. Podés consultar sin ese filtro.`);
  });
  return resultado;
}
